let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f8Qux")).then(() => parcelRequire('iPZ0w'));